import { useLocation } from 'react-router';
import { AB_TEST, AB_TEST_GROUP } from 'src/data/abTests';
import { getABTestValue } from 'src/data/abTests';
import { useCurrentUser } from 'src/store';
import { getWebsiteOrigin } from 'src/utils/lib/env';

const MOBILE_PAGE_SRC = {
  control: 'lp-mobile-a',
  experiment: 'lp-mobile-b',
};

export const useMobilePageIframeSrc = () => {
  const location = useLocation();
  const currentUser = useCurrentUser();
  const abValue = getABTestValue(currentUser, AB_TEST.mobileLandingPage);
  const pageName =
    abValue === AB_TEST_GROUP.experiment ? MOBILE_PAGE_SRC.experiment : MOBILE_PAGE_SRC.control;

  return `${getWebsiteOrigin()}/${pageName}${location.search}`;
};
